'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var baseStyle = {
  ml: 0.5
};
var RequiredIndicator = {
  baseStyle: baseStyle
};
exports["default"] = RequiredIndicator;